module.exports = __webpack_public_path__ + "img/car.41f2ba5d.png";